<template>
	<div id="login" class="two-factor-authentication">
		<div class="login-wrapper">
			<form class="login-form" method="POST" v-on:submit.prevent="validateCode">
				<div class="login-container">
					<div class="login-header">
						<Logo />
					</div>
					<div class="form-fields">
						<b-loading :is-full-page="false" :active="processing" />

						<h1 class="title is-4">Two Factor Authentication</h1>

						<b-notification type="is-danger" v-if="error" :closable="false">
							{{ error }}
						</b-notification>

						<p>
							We just sent you an email with your verification code.
							Please enter the code to continue. This code is valid for a limited time and can only be used once.
						</p>

						<b-field label="Authentication Code" :type="feedback.code.type" :message="feedback.code.message">
							<b-input id="mfa-code" v-model.trim="input.code" ref="code" type="code" autofocus placeholder="000000" custom-class="text-center" />
							<template #message v-if="!feedback.code.message">
								<small class="two-factor-resend">
									Didn't get a code? <a href="#" @click.prevent="resendCode">Resend Code</a>
								</small>
							</template>
						</b-field>
					</div>
					<div class="login-footer">
						<button class="button is-primary has-icon" :disabled="processing" type="submit">
							<b-icon icon="sign-in-alt"></b-icon>
							<span class="button-label">Continue</span>
						</button>

						<div class="two-factor-footnote" v-if="!userFromInviteLink">
							<p>
								Trying to log in with your username and password?
								<a href="/login" v-on:click.prevent="backToLogin"><strong>Click here</strong></a>
							</p>
						</div>
					</div>
				</div>
			</form>
			<p class="login-copyright">&copy; {{ new Date().getFullYear() }} &ndash; {{ title }}. All rights reserved.</p>
		</div>
	</div>
</template>

<script>
import Logo from './Icons/Logo'
import { mapGetters, mapMutations } from 'vuex'
import { AUTH_2FA_REQUEST, AUTH_2FA_RESEND_REQUEST, AUTH_LOGOUT } from '../store/actions/auth'

export default {
  components: {
    Logo
  },
  data () {
    return {
      title: process.env.NAME,
      input: {
        code: ''
      },
      feedback: {
        'code': {
          'type': '',
          'message': ''
        }
      },
      error: '',
      processing: false
    }
  },
  computed: mapGetters({
    isAuthenticated: 'isAuthenticated',
    userFromInviteLink: 'isFromInviteLink'
  }),
  methods: {
    ...mapMutations([
      'setPageTitle',
      'toggle2fa'
    ]),
    validateCode () {
      this.processing = true

      const { code } = this.input
      this.$store.dispatch(AUTH_2FA_REQUEST, { code }).then(response => {
        this.$awn.success(response.message)
        this.processing = false
        this.toggle2fa(false)
      }).catch(error => {
        this.processing = false
        this.input.code = ''

        if (error.response.data.response === 'error') {
          let fields = error.response.data.errors
          for (const prop in fields) {
            if (fields.hasOwnProperty(prop)) {
              if (this.feedback.hasOwnProperty(prop)) {
                this.feedback[prop].type = 'is-danger'
                this.feedback[prop].message = fields[prop]
              }
            }
          }
        }
      })
    },
    resendCode () {
      this.processing = true
      this.$store.dispatch(AUTH_2FA_RESEND_REQUEST).then(response => {
        this.processing = false
        this.$awn.success(response.message)
      }).catch(() => {
        this.processing = false
      })
    },
    backToLogin: function () {
      if (this.pusher) {
        this.pusher.allChannels()
          .forEach(channel => this.pusher.unsubscribe(channel.name))
      }

      this.$store.dispatch(AUTH_LOGOUT)
      this.$router.push({ name: 'login' })
    }
  },
  mounted () {
    this.setPageTitle('Two Factor Authentication Challenge')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TwoFactorChallenge.vue